import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "shortNumberFormatter",
    standalone: false
})
export class ShortNumberFormatterPipe implements PipeTransform {
  transform(input: any, args?: any): any {
    const suffixes = ["k", "M", "G", "T", "P", "E"];
    const decimalPlaces = 0;
    if (Number.isNaN(input)) {
      return null;
    }
    const isNegative = input < 0;
    input = Math.abs(input);

    if (input < 1000) {
      return (
        (isNegative === true ? "-" : "") +
        parseFloat(input).toFixed(decimalPlaces)
      );
    }

    const exp = Math.floor(Math.log(input) / Math.log(1000));

    return (
      (isNegative === true ? "-" : "") +
      (input / Math.pow(1000, exp)).toFixed(decimalPlaces) +
      suffixes[exp - 1]
    );
  }
}
